/* eslint-disable react/prop-types */

import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";
import { formatPhoneNumber } from "react-phone-number-input";
import moment from "moment";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

export default function tableConfig() {
  return {
    columns: [
      { Header: "Number", accessor: "number", align: "left" },
      { Header: "Description", accessor: "description", align: "left" },
      { Header: "Location", accessor: "location", align: "center" },
      { Header: "Timezone", accessor: "timezone", align: "center" },
      { Header: "SubAccount", accessor: "project", align: "center" },
      { Header: "Status", accessor: "status", align: "center" },
      { Header: "Created At", accessor: "createdAt", align: "center" },
      { Header: "Actions", accessor: "action", align: "center" },
    ],
    getRows: (data, locationData, timezoneData, setNumberToEdit) =>
      data.map((d) => ({
        number: formatPhoneNumber(d.number),
        description: d.description,
        location: locationData[d.location]?.name || "",
        timezone: timezoneData[d.timezone]?.text || "",
        project: d.project,
        status: (
          <MDBox ml={-1}>
            <MDBadge
              badgeContent={d.status === "1" ? "Active" : "Inactivte"}
              color={d.status === "1" ? "success" : "error"}
              variant="gradient"
              size="sm"
            />
          </MDBox>
        ),
        createdAt: d.createdAt ? moment(d.createdAt).locale("en").format("LLL") : "Never",
        action: (
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => setNumberToEdit(d)}
          >
            <Icon fontSize="small">edit</Icon>
          </IconButton>
        ),
      })),
  };
}
